"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.has = exports.get = exports.featureSwitch = exports.featureIf = exports.featureBranch = exports.default = void 0;
var _react = require("react");
var _recompose = require("../recompose");
var _globals = _interopRequireDefault(require("../globals"));
var _default = exports.default = _globals.default.features;
var has = exports.has = function has(key) {
  return _globals.default.features[key] !== undefined;
};
var get = exports.get = function get(key, defaultValue) {
  return has(key) ? _globals.default.features[key] : defaultValue;
};
var featureIf = exports.featureIf = function featureIf(key, left, right) {
  return get(key) === true ? left : right;
};
var featureSwitch = exports.featureSwitch = function featureSwitch(key, cases, defaultValue) {
  var value = get(key);
  if (value in cases) {
    return cases[value];
  }
  return defaultValue;
};

// HOC based on `recompose/branch`
var featureBranch = exports.featureBranch = function featureBranch(key, left, right) {
  return function (BaseComponent) {
    var leftFactory;
    var rightFactory;
    var BranchFeature = function BranchFeature(props) {
      if (get(key) === true) {
        if (!leftFactory) {
          leftFactory = /*#__PURE__*/(0, _react.createFactory)(left(BaseComponent));
        }
        return leftFactory(props);
      }
      if (!rightFactory) {
        rightFactory = /*#__PURE__*/(0, _react.createFactory)(right ? right(BaseComponent) : BaseComponent);
      }
      return rightFactory(props);
    };
    if (process.env.NODE_ENV !== 'production') {
      var displayName = (0, _recompose.wrapDisplayName)(BaseComponent, 'branchFeature');
      return (0, _recompose.setDisplayName)(displayName)(BranchFeature);
    }
    return BranchFeature;
  };
};